<section>
	<section>
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="modal fade" id="selectpg-popup" tabindex="-1" aria-labelledby="exampleModalLabel"
						aria-hidden="true">
						<div class="modal-dialog">
							<div class="modal-content">
								<div class="modal-body mdltp-txtcont">
									<h3>Forgot Password</h3>
									<form [formGroup]="forgotPasswordForm">
									<div class="my-4">
										<label for="employeeCode" class="form-label">Employee Code</label>
										<input type="text" class="form-control" formControlName="employeeCode" id="employeeCode"
											placeholder="Enter Employee Code"
											[ngClass]="{ 'is-invalid':  f['employeeCode'].errors && (f['employeeCode'].touched)}">
										<app-validation field="employeeCode" [form]="forgotPasswordForm"
											[error]="{required:'This is a mandatory field', minlength:'Employee Code must be greater than 3'}"></app-validation>
									</div>
									</form>
									<div class="btnpopdv text-center">
										<button type="button" class="btn-popup" (click)='exit()()'>Exit</button>
										<button type="button" class="btn-popup" (click)='submit()'>SUBMIT</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>